import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AdminWrapperComponent } from './admin-wrapper/admin-wrapper.component';
import { AdminRoutingModule } from './admin-routing.module';
import { AihLaunchpadCoreModule, ExportDropdownComponent, LocalisedDatePipe } from 'aih-launchpad-core';
import { TranslateModule } from '@ngx-translate/core';
import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { UserListWrapperComponent } from './user-list-wrapper/user-list-wrapper.component';
import {
  NgbDropdownModule,
  NgbOffcanvasModule,
  NgbPopover,
  NgbTooltipModule,
  NgbTypeaheadModule
} from '@ng-bootstrap/ng-bootstrap';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from '../../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from 'angular-auth-oidc-client';
import { UserDataGridComponent } from './user-list-wrapper/user-data-grid/user-data-grid.component';
import { OrganisationSelectorComponent } from './organisation-selector/organisation-selector.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OrganisationListWrapperComponent } from './organisation-list-wrapper/organisation-list-wrapper.component';
import { OrganisationDataGridComponent } from './organisation-list-wrapper/organisation-data-grid/organisation-data-grid.component';
import { NewUserComponent } from './new-user/new-user.component';
import { UserAppSelectorComponent } from './new-user/user-app-selector/user-app-selector.component';
import { UnauthorisedErrorPageComponent } from './unauthorised-error-page/unauthorised-error-page.component';
import { SelectedOrganisationsPanelComponent } from './organisation-selector/selected-organisations-panel/selected-organisations-panel.component';
import { MultipleOrganisationSelectorComponent } from './multiple-organisation-selector/multiple-organisation-selector.component';
import { UserAppEntryComponent } from './new-user/user-app-selector/user-app-entry/user-app-entry.component';
import { ActivateUserModalComponent } from './activate-user-modal/activate-user-modal.component';
import { RoleNameTranslationDirective } from './directives/role-name-translation.directive';
import { UserRolesSlideoutWrapperComponent } from './user-slideout/user-roles-slideout-wrapper/user-roles-slideout-wrapper.component';
import { UserRolesSlideoutComponent } from './user-slideout/user-roles-slideout-wrapper/user-roles-slideout/user-roles-slideout.component';
import { UserSlideoutComponent } from './user-slideout/user-slideout.component';
import {
  UserOrgsSlideoutComponent
} from './user-slideout/user-orgs-slideout-wrapper/user-orgs-slideout/user-orgs-slideout.component';
import {
  UserOrgsSlideoutWrapperComponent
} from './user-slideout/user-orgs-slideout-wrapper/user-orgs-slideout-wrapper.component';
import { UserGridEntryComponent } from './user-list-wrapper/user-data-grid/user-grid-entry/user-grid-entry.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImpersonateUserModalComponent } from './impersonate-user-modal/impersonate-user-modal.component';

@NgModule({
  declarations: [
    AdminWrapperComponent,
    MenuBarComponent,
    UserListWrapperComponent,
    UserDataGridComponent,
    OrganisationSelectorComponent,
    OrganisationListWrapperComponent,
    OrganisationDataGridComponent,
    NewUserComponent,
    UserAppSelectorComponent,
    UnauthorisedErrorPageComponent,
    SelectedOrganisationsPanelComponent,
    MultipleOrganisationSelectorComponent,
    UserOrgsSlideoutComponent,
    UserOrgsSlideoutWrapperComponent,
    UserAppEntryComponent,
    ActivateUserModalComponent,
    RoleNameTranslationDirective,
    UserRolesSlideoutWrapperComponent,
    UserRolesSlideoutComponent,
    UserSlideoutComponent,
    UserGridEntryComponent,
    SearchBoxComponent,
    ImpersonateUserModalComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    AihLaunchpadCoreModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgbTooltipModule,
    NgbPopover,
    NgbTypeaheadModule,
    NgOptimizedImage,
    NgbDropdownModule,
    NgbOffcanvasModule,
    ScrollingModule,
    LocalisedDatePipe,
    ExportDropdownComponent
  ],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory(httpLink: HttpLink) {
        return {
          cache: new InMemoryCache({ addTypename: false }),
          link: httpLink.create({
            uri: environment.launchpadGraphEndpoint
          })
        }
      }
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ]
})
export class AdminModule { }
